import React, { useState, useEffect } from 'react';
import api from "../../api/axios";
import ModelSelect from "../ui/ModelSelect";

const Taux = () => {
  const [retouches, setRetouches] = useState([]);
  const [models, setModels] = useState([]);
  const [chains, setChains] = useState([]);
  const [posts, setPosts] = useState([]);
  const [totalExport, setTotalExport] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedChain, setSelectedChain] = useState('');
  const [loadingPosts, setLoadingPosts] = useState(false);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const modelsResponse = await api.get("/models");
        setModels(modelsResponse.data);
      } catch (error) {
        console.error('Error fetching models:', error);
      }
    };

    const fetchChains = async () => {
      try {
        const response = await api.get("/chains");
        setChains(response.data);
      } catch (error) {
        console.error("Error fetching chains:", error);
      }
    };

    fetchChains();
    fetchModels();
  }, []);

  useEffect(() => {
    const fetchPosts = async () => {
      if (selectedModel) {
        setLoadingPosts(true);
        try {
          const response = await api.get(`/posts?model_id=${selectedModel}`);
          setPosts(response.data);
        } catch (error) {
          console.error('Error fetching posts:', error);
          setPosts([]);
        } finally {
          setLoadingPosts(false);
        }
      } else {
        setPosts([]);
        setLoadingPosts(false);
      }
    };

    fetchPosts();
  }, [selectedModel]);

  useEffect(() => {
    const fetchRetouchData = async () => {
      try {
        const response = await api.get('/retouch');
        console.log(response.data)
        setRetouches(response.data);
      } catch (error) {
        console.error('Error fetching retouch data:', error);
      }
    };

    const getExport = async (modelId) => {
      try {
        const response = await api.get(`/export/${modelId}`);
        const exportData = response.data;
        setTotalExport(exportData.total);
      } catch (error) {
        console.error('Error fetching export data:', error);
      }
    };

    if (selectedModel) {
      fetchRetouchData();
      getExport(selectedModel);
    } else {
      setRetouches([]);
      setTotalExport(0);
    }
  }, [selectedModel]);

  useEffect(() => {
    if (retouches.length > 0) {
      filterData();
    } else {
      setFilteredData([]);
    }
  }, [selectedModel, selectedChain, retouches]);

  const filterData = () => {
    let filtered = retouches;

    if (selectedModel) {
      filtered = filtered.filter(item => item.model_id == selectedModel);
    }

    if (selectedChain) {
      filtered = filtered.filter(item => item.chain_id == selectedChain);
    }

    setFilteredData(filtered);
  };

  const calculatePercentage = (controlFinal, total) => {
    return total > 0 ? ((controlFinal / total) * 100).toFixed(1) + '%' : '0%';
  };

  const handleModelChange = (e) => {
    const newModelId = e.target.value;
    setSelectedModel(newModelId);
    setSelectedChain(''); // Clear chain selection when model changes
    setPosts([]); // Clear posts when model changes
    setFilteredData([]); // Clear filtered data
    setTotalExport(0); // Clear export total
    setRetouches([]); // Clear retouches data
  };

  const handleChainChange = (e) => {
    setSelectedChain(e.target.value);
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="ml-7 mb-9 text-2xl font-semibold">
          Retouch Data Table
          {selectedModel && (
            <span className="ml-3 text-lg text-blue-600 font-normal">
              - {models.find(m => m.id == selectedModel)?.modele}
            </span>
          )}
        </h2>

        <div  className="flex items-center justify-between">
          <ModelSelect className="ml-7 mb-4 mt-4 w-60" onChange={handleModelChange} value={selectedModel} models={models} />

          <select 
            className="block ml-7 mb-4 w-fit mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
            onChange={handleChainChange} value={selectedChain}>
            <option value="">Select Chain (Sortie)</option>
            {chains.map(chain => (
              <option key={chain.id} value={chain.id}>
                {chain.name}
              </option>
            ))}
          </select>
          
          {selectedChain && (
            <div className="ml-4 text-sm text-blue-600 font-medium">
              Chain: {chains.find(c => c.id == selectedChain)?.name}
            </div>
          )}
        </div>
      </div>

      {!selectedModel ? (
        <div className="ml-7 mt-5 text-center text-gray-500">
          Please select a model to view retouch data
        </div>
      ) : loadingPosts ? (
        <div className="ml-7 mt-5 text-center text-gray-500">
          Loading posts...
        </div>
      ) : posts.length === 0 ? (
        <div className="ml-7 mt-5 text-center text-gray-500">
          No posts found for the selected model
        </div>
      ) : filteredData.length === 0 ? (
        <div className="ml-7 mt-5 text-center text-gray-500">
          No retouch data available for the selected model
        </div>
      ) : (
        <>
          <table style={{width: '96%'}} className="ml-7 bg-slate-200 mt-5">
            <thead>
              <tr>
                <th className="px-6 text-center py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider min-w-[150px]">Post</th>
                <th className="px-6 text-center py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider min-w-[150px]">Info Type</th>
                <th className="px-6 text-center py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider min-w-[150px]">Controle Table</th>
                <th className="px-6 text-center py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider min-w-[150px]">Controle Final</th>
              </tr>
            </thead>
            <tbody>
              {posts.map(post => {
                const postRetouchData = filteredData.filter(item => item.post && item.post.id == post.id);
                const totalRetouch = postRetouchData.reduce((sum, item) => sum + item.value, 0);
                
                // Show message when no retouch data for this post
                if (postRetouchData.length === 0) {
                  return (
                    <tr key={post.id} className="bg-gray-50">
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">{post.name}</td>
                      <td colSpan="3" className="p-[2rem] text-center text-gray-500 italic">
                        {selectedChain ? 'No retouch data for this chain' : 'No retouch data available'}
                      </td>
                    </tr>
                  );
                }
                
                return (
                  <React.Fragment key={post.id}>
                    <tr className="bg-gray-50">
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]" rowSpan="2">{post.name}</td>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">NBR</td>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">{selectedChain ? totalRetouch : ''}</td>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">{!selectedChain ? totalRetouch : ''}</td>
                    </tr>
                    <tr>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">%</td>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">{selectedChain ? calculatePercentage(totalRetouch, totalExport) : ''}</td>
                      <td className="p-[2rem] text-center text-[#4E4A4A] font-semibold min-w-[150px]">{!selectedChain ? calculatePercentage(totalRetouch, totalExport) : ''}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
              
              {/* Summary Row */}
              <tr className="bg-blue-50 border-t-2 border-blue-300">
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">TOTAL</td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">NBR</td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">
                  {selectedChain ? filteredData.reduce((sum, item) => sum + item.value, 0) : ''}
                </td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">
                  {!selectedChain ? filteredData.reduce((sum, item) => sum + item.value, 0) : ''}
                </td>
              </tr>
              <tr className="bg-blue-50">
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]"></td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">%</td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">
                  {selectedChain ? calculatePercentage(filteredData.reduce((sum, item) => sum + item.value, 0), totalExport) : ''}
                </td>
                <td className="p-[2rem] text-center text-[#4E4A4A] font-bold min-w-[150px]">
                  {!selectedChain ? calculatePercentage(filteredData.reduce((sum, item) => sum + item.value, 0), totalExport) : ''}
                </td>
              </tr>
            </tbody>
          </table>
          
          {/* Summary Information */}
          {totalExport > 0 && (
            <div className="ml-7 mt-4 p-4 bg-gray-100 rounded-lg">
              <div className="text-sm text-gray-600">
                <strong>Total Export:</strong> {totalExport.toLocaleString()}
              </div>
              {selectedChain && (
                <div className="text-sm text-gray-600 mt-1">
                  <strong>Selected Chain:</strong> {chains.find(c => c.id == selectedChain)?.name}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Taux;
